import { Component } from '@theme/component';

/**
 * Crossfades the desktop hero photos.
 *
 * Deliberately has no visible controls: the hero is meant to read as one image
 * that happens to change, and the owner asked for the video's pause button to
 * go for the same reason.
 */
class HeroSlideshow extends Component {
  requiredRefs = ['slides'];

  connectedCallback() {
    super.connectedCallback();

    this.slides = Array.isArray(this.refs.slides) ? this.refs.slides : [this.refs.slides];
    // One photo is not a slideshow.
    if (this.slides.length < 2) return;

    this.index = 0;
    const seconds = parseFloat(this.dataset.interval);
    this.interval = (Number.isFinite(seconds) ? Math.max(3, seconds) : 5) * 1000;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.reducedMotion.addEventListener('change', this.onMotionPreferenceChange);
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    if (!this.reducedMotion.matches) this.start();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.stop();
    this.reducedMotion?.removeEventListener('change', this.onMotionPreferenceChange);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  start() {
    this.stop();
    this.timer = setInterval(this.next, this.interval);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  next = () => {
    const current = this.slides[this.index];
    this.index = (this.index + 1) % this.slides.length;
    const upcoming = this.slides[this.index];

    current.classList.remove('is-active');
    current.setAttribute('aria-hidden', 'true');
    upcoming.classList.add('is-active');
    upcoming.setAttribute('aria-hidden', 'false');
  };

  onMotionPreferenceChange = (event) => {
    if (event.matches) this.stop();
    else this.start();
  };

  // Nothing to animate on a tab nobody is looking at.
  onVisibilityChange = () => {
    if (document.hidden) this.stop();
    else if (!this.reducedMotion.matches) this.start();
  };
}

if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', HeroSlideshow);
}
